import { useState, useEffect } from 'react';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebase';

/**
 * Custom hook to fetch 28-day check-ins trend from systemStats.
 * Returns total check-ins count in chronological order for sparklines.
 */
function useCheckinsTrend() {
  const [trendData, setTrendData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTrendData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch last 28 daily entries ordered by date desc, then reverse to chronological
        const statsRef = collection(db, 'systemStats');
        const statsQuery = query(statsRef, orderBy('date', 'desc'), limit(28));
        const querySnapshot = await getDocs(statsQuery);

        if (!querySnapshot.empty) {
          const data = querySnapshot.docs.map((doc) => {
            const docData = doc.data();
            return {
              date: docData.date?.toDate?.() || new Date(docData.date),
              checkinsCount: docData.metrics?.totalCheckinsCount || 0,
            };
          });
          setTrendData(data.reverse());
        } else {
          setTrendData([]);
        }
      } catch (err) {
        console.error('Error fetching check-ins trend data:', err);
        setError(err.message);
        setTrendData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTrendData();
  }, []);

  return { trendData, loading, error };
}

export default useCheckinsTrend;
